import { useRMSelector } from 'redux/hooks';
export const useSelectedHitButton = () => {
  return useRMSelector((state) => state.headers.hitButton);
};

export const useHitScoreGroupType = () => {
  return useRMSelector((state) => state.headers.hitScoreGroupType);
};

export const useHitScoreGroup = () => {
  return useRMSelector((state) => state.headers.hitScoreGroup);
};

export const useUvHitsOnly = () => {
  return useRMSelector((state) => state.headers.uvHitsOnly);
};

export const useSelectedHitScoreGroups = () => {
  return useRMSelector((state) => state.headers.selectedHitScoreGroups);
};
